import {
  CSSProperties, lazy, ReactNode, Suspense,
} from 'react';

import { LazyResolver } from '@ezugi/ui/components/LazyResolver/LazyResolver';
import { isEvoWrapped } from '@ezugi/utils/src';

const EzugiGameFooter = lazy(
  () => import('../../variants/components/ezugi/EzugiGameFooter/EzugiGameFooter')
);

const EvoGameFooter = lazy(
  () => import('../../variants/components/evo/EvoGameFooter/EvoGameFooter')
);

const variants = {
  evo: EvoGameFooter,
  ezugi: EzugiGameFooter,
};

export type GameFooterProps = {
  children?: ReactNode;
  className?: string;
  legacy?: boolean;
  showSeconds?: boolean;
  gradient?: boolean;
  style?: CSSProperties;
};

const GameFooter = (props: GameFooterProps) => {
  const evoWrapped = isEvoWrapped();

  return (
    <Suspense fallback={null}>
      <LazyResolver
        components={variants}
        componentProps={props}
        variant={evoWrapped ? 'evo' : 'ezugi'}
      />
    </Suspense>
  );
};

export default GameFooter;
